import { Component, h, Prop, State } from '@stencil/core';
import dayjs from 'dayjs';
import { IDatePartModel } from '../../models/date-part.model';

@Component({
  tag: 'pnk-date-part-selector',
  styleUrl: 'pnk-date-part-selector.css',
})
export class PnkDatePartSelector {
  @Prop() show: boolean = false;

  @Prop() mode: string = 'd';

  @Prop() date: Date = new Date();

  @Prop() dataSource: IDatePartModel[] = [];

  @Prop() dateChange!: (date: Date) => void;

  @State() start: number = 0;

  @State() end: number = 10; // from 0 to 10 where 0 and 10 are arrows to show other years and numbers from 1 to 9 are the years currently in the range

  @State() years: IDatePartModel[] = [];

  @State() disabled: boolean = false;

  render() {
    return (
      <div class="pnk-absolute pnk-right-0">
        {this.show && (
          <div class="pnk-w-[262px] pnk-h-[130px] pnk-bg-disabled-base pnk-text-black pnk-text-[15px] pnk-grid pnk-grid-cols-3 pnk-rounded pnk-p-[5px]">
            <button
              class="pnk-justify-center pnk-items-center pnk-w-[84px] pnk-h-[30px] pnk-flex pnk-cursor-pointer hover:pnk-bg-primary-base hover:pnk-text-white hover:pnk-rounded"
              id="next"
              onClick={() => this.next()}
            >
              +10
            </button>
            {
              (this.years = [
                ...this.dataSource.slice(this.start, this.end).map((item: IDatePartModel) => (
                  <span
                    class="pnk-justify-center pnk-items-center pnk-w-[84px] pnk-h-[30px] pnk-flex pnk-cursor-pointer hover:pnk-bg-primary-base hover:pnk-text-white hover:pnk-rounded"
                    onClick={() => this.setValue(item)}
                  >
                    {item.name}
                  </span>
                )),
              ])
            }
            <button
              class="pnk-justify-center pnk-items-center pnk-w-[84px] pnk-h-[30px] pnk-flex pnk-cursor-pointer hover:pnk-bg-primary-base hover:pnk-text-white hover:pnk-rounded"
              id="prev"
              onClick={() => this.prev()}
            >
              -10
            </button>
          </div>
        )}
      </div>
    );
  }

  next() {
    if (this.start === 0) {
      //
    } else {
      this.start -= 10;
      this.end -= 10;
    }
  }

  prev() {
    if (this.end >= this.dataSource.length) {
      //
    } else {
      this.start += 10;
      this.end += 10;
    }
  }

  private setValue(item: IDatePartModel): void {
    let _mode: dayjs.UnitType = 'year';
    switch (this.mode) {
      case 'd':
        _mode = 'date';
        break;
      case 'm':
        _mode = 'month';
        break;
      default:
        _mode = 'year';
        break;
    }
    const newDate: Date = dayjs(this.date).set(_mode, item.value).clone().toDate();
    this.dateChange(newDate);
  }
}
